<template>
  <v-os-popup
    v-model="isShow"
    :title="giftParams.giftType == 43 ? '整点加赠':'赠品'"
    @footerClick="handleChange"
    @close="handleClose"
    :footerShow="isFooterShow"
    container="body"
  >
    <p class="tip" v-if="giftParams.giftType != 43">数量有限，赠完即止</p>
    <div class="g-pop-box">
      <!--正在进行中整点加赠 -->
      <OnTheHour v-if="giftParams.giftType == 43" :timeGift="giftParams.list" class="g-pop-item" :pageName="giftParams.pageName"/>
      <div class="optional-gifts-module" v-else>
        <OptionalGifts
          v-for="item in optionalList"
          :key="item.optionalGiftId"
          :list="item.list"
          :optionalGiftId="item.optionalGiftId"
          :selectNums="item.selectNums"
          :pageName="giftParams.pageName"
          @select="handleGiftSelect"
        ></OptionalGifts>
      </div>
    </div>
  </v-os-popup>
</template>
<script>
import OnTheHour from './on-the-hour'
import OptionalGifts from './optional-gifts'
export default {
  name: 'GiftPopup',
  components: {
    OnTheHour,
    OptionalGifts
  },
  props: {
    giftParams: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
  },
  data(){
    return {
      optionalList: []
    }
  },
  watch:{
    isShow(val){
      if(val && this.giftParams.giftType != 43){
        this.optionalList = JSON.parse(JSON.stringify(this.giftParams.list))
      }
    }
  },
  computed: {
    isShow(){
      return this.giftParams.isShow
    },
    isFooterShow(){
      return this.giftParams.giftType != 43
    }
  },
  methods: {
    handleGiftSelect(optionalGiftId, selectIdList) {
      this.optionalList
        .find(item => item.optionalGiftId == optionalGiftId)
        .list.forEach(item => {
          if (selectIdList.includes(item.id)) {
            item.canOptional = 1
          } else {
            item.canOptional = 0
          }
        })
    },
    handleClose(){
      this.$emit('close')
    },
    // 修改已选数据
    handleChange(){
      this.$emit('change', {
        optionalList: this.optionalList,
        options: this.giftParams.options // 透传参数
      })
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.tip {
  position: relative;
  font-size: 39px;
  @include os-font-weight(39, 40);
  color: #888888;
  margin-top: -48px;
  margin-bottom: 90px;
  text-align: center;
}
.g-pop-box {
  box-sizing: border-box;
}

</style>